<section class="contract-list-page">
  <mat-card class="page-card">
    <mat-card-content>
      <header class="page-header">
        <div class="page-header-main">
          <button mat-icon-button type="button" class="back-button" matTooltip="Voltar ao Dashboard" (click)="returnToDashboard()">
            <mat-icon>arrow_back</mat-icon>
          </button>

          <div class="title-group">
            <span class="title-icon">
              <mat-icon>description</mat-icon>
            </span>
            <div>
              <h1>Contratos</h1>
              <p>Consulte seus contratos ativos e finalizados.</p>
            </div>
          </div>
        </div>
      </header>

      <section class="info-banner" *ngIf="hasContracts">
        <mat-icon>info</mat-icon>
        <div>
          <strong>{{ summaryText }}</strong>
          <span>Acompanhe o status, o box contratado e o próximo pagamento de cada contrato.</span>
        </div>
      </section>

      <ng-container *ngIf="hasContracts; else emptyState">
        <div class="desktop-table">
          <table>
            <thead>
            <tr>
              <th>Nº do contrato</th>
              <th>Unidade</th>
              <th>Box</th>
              <th>Data de locação</th>
              <th>Finalizado em</th>
              <th>Próximo pagamento</th>
              <th class="align-right">Mensalidade</th>
              <th>Status</th>
              <th class="align-center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let contract of contracts; trackBy: trackByContract">
              <td>
                <div class="cell-stack">
                  <strong class="primary-value">{{ contract.GEN_CONTRATO }}</strong>
                </div>
              </td>

              <td>
                <div class="cell-stack">
                  <strong>{{ unitName(contract) }}</strong>
                  <span>{{ unitSubtitle() }}</span>
                </div>
              </td>

              <td>
                <div class="cell-stack">
                  <strong>{{ boxName(contract) }}</strong>
                  <span>{{ boxSubtitle(contract) }}</span>
                </div>
              </td>

              <td>
                <div class="cell-stack">
                  <strong>{{ formatDate(contract.DATA_LOCACAO) }}</strong>
                  <span>{{ contractAgeText(contract) }}</span>
                </div>
              </td>

              <td>
                <div class="cell-stack">
                  <ng-container *ngIf="isActive(contract); else finishedDate">
                    <mat-chip class="soft-chip success-chip">Em vigor</mat-chip>
                    <span>{{ finalizedText(contract) }}</span>
                  </ng-container>

                  <ng-template #finishedDate>
                    <strong>{{ formatDate(contract.FINALIZAR_CONTRATO_DATA || contract.DATA_FINALIZAR) }}</strong>
                    <span>{{ finalizedText(contract) }}</span>
                  </ng-template>
                </div>
              </td>

              <td>
                <div class="cell-stack">
                  <strong [ngClass]="'tone-' + nextPaymentTone(contract)">{{ nextPaymentDate(contract) }}</strong>
                  <span [ngClass]="'tone-' + nextPaymentTone(contract)">{{ nextPaymentText(contract) }}</span>
                </div>
              </td>

              <td class="align-right">
                <div class="cell-stack align-end">
                  <strong class="primary-value">{{ formatCurrency(contract.VALOR_MENSALIDADE) }}</strong>
                  <span>Mensal</span>
                </div>
              </td>
              <td>
                <mat-chip [ngClass]=" '' +  isActive(contract) ? 'success-chip' : 'neutral-chip'" class="soft-chip" [class.success-chip]="isActive(contract)" [class.neutral-chip]="!isActive(contract)">
                  <mat-icon>{{ statusIcon(contract) }}</mat-icon>
                  {{ statusLabel(contract) }}
                </mat-chip>
              </td>

              <td class="align-center">
                <button mat-stroked-button type="button" class="details-button" (click)="openContract(contract.GEN_CONTRATO)">
                  <mat-icon>visibility</mat-icon>
                  Ver detalhes
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mobile-cards">
          <mat-card class="contract-mobile-card" *ngFor="let contract of contracts; trackBy: trackByContract">
            <mat-card-content>
              <div class="mobile-card-header">
                <div>
                  <span class="eyebrow">Contrato</span>
                  <h2>#{{ contract.GEN_CONTRATO }}</h2>
                </div>

                <mat-chip class="soft-chip" [class.success-chip]="isActive(contract)" [class.neutral-chip]="!isActive(contract)">
                  <mat-icon>{{ statusIcon(contract) }}</mat-icon>
                  {{ statusLabel(contract) }}
                </mat-chip>
              </div>

              <div class="mobile-grid">
                <div class="mobile-field">
                  <span>Unidade</span>
                  <strong>{{ unitName(contract) }}</strong>
                  <small>{{ unitSubtitle() }}</small>
                </div>

                <div class="mobile-field">
                  <span>Box</span>
                  <strong>{{ boxName(contract) }}</strong>
                  <small>{{ boxSubtitle(contract) }}</small>
                </div>

                <div class="mobile-field">
                  <span>Próximo pagamento</span>
                  <strong [ngClass]="'tone-' + nextPaymentTone(contract)">{{ nextPaymentDate(contract) }}</strong>
                  <small [ngClass]="'tone-' + nextPaymentTone(contract)">{{ nextPaymentText(contract) }}</small>
                </div>

                <div class="mobile-field">
                  <span>Mensalidade</span>
                  <strong>{{ formatCurrency(contract.VALOR_MENSALIDADE) }}</strong>
                  <small>Mensal</small>
                </div>
              </div>

              <button mat-stroked-button type="button" class="details-button full-width" (click)="openContract(contract.GEN_CONTRATO)">
                <mat-icon>visibility</mat-icon>
                Ver detalhes
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>

<!--      <section class="help-card">-->
<!--        <div>-->
<!--          <h2>Precisa de ajuda?</h2>-->
<!--          <p>Entre em contato com nossa equipe caso tenha dúvidas sobre seus contratos.</p>-->
<!--        </div>-->

<!--        <button mat-stroked-button type="button" class="details-button" (click)="contactSupport()">-->
<!--          <mat-icon>support_agent</mat-icon>-->
<!--          Fale conosco-->
<!--        </button>-->
<!--      </section>-->
    </mat-card-content>
  </mat-card>
</section>

<ng-template #emptyState>
  <section class="empty-state">
    <div class="empty-icon">
      <mat-icon>description</mat-icon>
    </div>
    <h2>Você ainda não possui contratos cadastrados.</h2>
    <p>Quando houver contratos vinculados ao seu cadastro, eles aparecerão aqui.</p>
  </section>
</ng-template>
